export const ENV = (key: string): string => {
  return (window as any)[key] ?? process.env[key];
};
